module.exports = __webpack_public_path__ + "static/media/office11.e77df312.jpg";